import { registerPlugin } from '@capacitor/core';
const Motion = registerPlugin('Motion', {
    android: () => import('./web').then(m => new m.MotionWeb()),
    ios: () => import('./web').then(m => new m.MotionWeb()),
    web: () => import('./web').then(m => new m.MotionWeb()),
});
export * from './definitions';
export { Motion };
//# sourceMappingURL=index.js.map